
import {eventClassList} from "./constants/eventClassList";


$(document).ready(() => {
    eventClassList.forEach(setClickEvents)
    eventClassList.forEach(setChangeEvents)

    document.body.addEventListener('undoRedoUpdated', (event) => {
        if(event.detail.isUndoAvailable){
            document.querySelector(".js-undo").classList.remove("disabled")
        }else{
            document.querySelector(".js-undo").classList.add("disabled")
        }
        if(event.detail.isRedoAvailable){
            document.querySelector(".js-redo").classList.remove("disabled")
        }else{
            document.querySelector(".js-redo").classList.add("disabled")
        }
    });
    // document.body.addEventListener("updatedMarginHorizontal", (evt) => {
    //     document.querySelector("#hor-margin").value = evt.detail.value;
    //     document.querySelector("#hor-margin").dispatchEvent( new Event('input', document.querySelector("#hor-margin") ));
    // })
    // document.body.addEventListener("updatedMarginVertical", (evt) => {
    //     document.querySelector("#ver-margin").value = evt.detail.value;
    //     document.querySelector("#ver-margin").dispatchEvent( new Event('input', document.querySelector("#ver-margin") ));
    // })
    document.body.addEventListener("updatedEdgeSlant", (evt) => {
        document.querySelector("#max-edge").value = evt.detail.value;
        document.querySelector("#max-edge").dispatchEvent( new Event('input', document.querySelector("#max-edge") ));
    })
    document.body.addEventListener("updatedGridWidth", (evt) => {
        document.querySelector("#width-size").value = evt.detail.value;
        document.querySelector("#width-size").dispatchEvent( new Event('input', document.querySelector("#width-size") ));
    })
    document.body.addEventListener("updatedGridHeight", (evt) => {
        document.querySelector("#height-size").value = evt.detail.value;
        document.querySelector("#height-size").dispatchEvent( new Event('input', document.querySelector("#height-size") ));
    })
})


const setChangeEvents = (x) => {
    var from = document.querySelector(x.from);

    if (from != null) {

        from.addEventListener("change", () => {
            var el = document.querySelector(x.to)
            el.value = from.value
            el.dispatchEvent(new Event('change'));
        })
    }
}
const setClickEvents = (x) => {
    var from = document.querySelector(x.from);

    if (from != null) {
        from.addEventListener("click", () => document.querySelector(x.to).click());
    }
}




// WEBPACK FOOTER //
// ./scripts/components/silver-decision-extensions.js